if (!window.Eurus.loadedScript.has('sticky-atc.js')) {
  window.Eurus.loadedScript.add('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xStickyATC', (sectionId, is_combined) => ({
        openDetailOnMobile: false,
        currentAvailableOptions: [],
        options: [],
        init() {
          if (!is_combined) {
            this.variants = xParseJSON(this.$el.getAttribute('x-variants-data'));
          }

          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            if (is_combined) {
              this.renderVariant(e.detail.html);
            } else {
              this.currentAvailableOptions = e.detail.currentAvailableOptions,
              this.options = e.detail.options;
            }

            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);
          });

          // Watch openDetailOnMobile to hide/show Gorgias chat elements on mobile
          this.$watch('openDetailOnMobile', (isOpen) => {
            this.toggleGorgiasChatVisibility(isOpen);
          });

          // Watch for Recharge selling plan selection and hide sticky bar when selected
          this.initSellingPlanObserver();
        },
        initSellingPlanObserver() {
          const productInfo = document.querySelector('.product-info');
          if (!productInfo) return;

          // Get the parent Alpine component that owns hideForRecharge
          const parentWrapper = this.$el.closest('[x-data*="hideForRecharge"]');
          if (!parentWrapper) return;
          const parentData = Alpine.$data(parentWrapper);

          const checkSellingPlan = () => {
            const selectedInput = productInfo.querySelector('input.rc_widget__option__input:checked');
            // Hide sticky bar if subscription is selected (not one-time)
            parentData.hideForRecharge = selectedInput && !selectedInput.classList.contains('rc_widget__option__input--onetime');
          };

          // Check immediately in case selling plan is already selected
          checkSellingPlan();

          // Watch for Recharge widget injection and changes
          const observer = new MutationObserver(() => {
            const rcInputs = productInfo.querySelectorAll('input.rc_widget__option__input');
            if (rcInputs.length > 0) {
              checkSellingPlan();
              // Add change listeners if not already added
              rcInputs.forEach((input) => {
                if (!input.hasAttribute('data-sticky-listener')) {
                  input.setAttribute('data-sticky-listener', 'true');
                  input.addEventListener('change', checkSellingPlan);
                }
              });
            }
          });

          observer.observe(productInfo, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['checked', 'class']
          });
        },
        toggleGorgiasChatVisibility(hide) {
          // Find all elements with class names starting with 'gorgias-chat-key'
          const gorgiasElements = document.querySelectorAll('[class*="gorgias-chat-key"]');
          gorgiasElements.forEach((el) => {
            if (hide) {
              el.style.opacity = '0';
              el.style.pointerEvents = 'none';
              el.style.transition = 'opacity 0.3s ease';
            } else {
              el.style.opacity = '';
              el.style.pointerEvents = '';
            }
          });
        },
        renderProductPrice(html) {
          const destinations = document.querySelectorAll(`.price-sticky-${sectionId}`);
          destinations.forEach((destination) => {
            const source = html.getElementById('price-sticky-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          })
        },
        renderMedia(html) {
          const destination = document.getElementById('product-image-sticky-' + sectionId);
          const source = html.getElementById('product-image-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        renderVariant(html) {
          const destination = document.getElementById('variant-update-sticky-' + sectionId);
          const source = html.getElementById('variant-update-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        changeOptionSticky(event) {
          Array.from(event.target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          event.target.selectedOptions[0].setAttribute('selected', 'selected');
          const input = event.target.selectedOptions[0];
          const inputId = input.id;
          const targetUrl = input.dataset.productUrl;
          const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: {
              inputId: inputId,
              targetUrl: targetUrl,
              variantElSticky: variantEl
            }
          }));
        },
        onStickyGroupedChange(event) {
          const selectedOption = event.target.selectedOptions[0];
          const variantId = selectedOption.value;
          const productId = selectedOption.dataset.productId;
          const isAvailable = selectedOption.dataset.available === 'true';

          // Update hidden variant input for the sticky form
          const variantInputs = document.querySelectorAll(`[id='update-variant-sticky-${sectionId}']`);
          variantInputs.forEach((input) => (input.value = variantId));

          // Also update the main form's hidden variant input
          const mainVariantInputs = document.querySelectorAll(`[id='update-variant-${sectionId}']`);
          mainVariantInputs.forEach((input) => (input.value = variantId));

          // Update hidden product id if present
          const productInputs = document.querySelectorAll("input[name='product-id']");
          productInputs.forEach((input) => (input.value = productId));

          // Swap price HTML from the grouped price map
          const priceMap = document.querySelector(`#grouped-price-map-sticky-${sectionId}`);
          const priceDestinations = document.querySelectorAll(`.price-sticky-${sectionId}`);
          if (priceMap && priceMap.content) {
            const node = priceMap.content.querySelector(`[data-vid='${variantId}']`);
            if (node) {
              priceDestinations.forEach((destination) => {
                destination.innerHTML = node.innerHTML;
              });
            }
          }

          // Toggle ATC buttons based on availability
          const addToCartButtons = document.querySelectorAll(`[id='x-atc-button-${sectionId}']`);
          addToCartButtons.forEach((button) => {
            const text = button.querySelector('.button-text');
            if (isAvailable) {
              button.removeAttribute('disabled');
              if (text && window.Eurus && window.Eurus.atc) {
                text.textContent = window.Eurus.atc;
              }
            } else {
              button.setAttribute('disabled', 'disabled');
              if (text && window.Eurus && window.Eurus.oos) {
                text.textContent = window.Eurus.oos;
              }
            }
          });
        }
      }))
    })
  })
}
